import React from "react";
import ContentPreviewCompact from "../ContentPreviewCompact";

export default function ResultPreview({
  selectedContent,
  isSingleFileSelection,
}: {
  selectedContent: Content[];
  isSingleFileSelection: boolean;
}) {
  if (selectedContent.length === 0) return null;

  const style = {
    gridTemplateColumns: `repeat(${selectedContent.length}, 1fr)`,
  };

  return (
    <div className="grid merge-result-preview mt1 mb1" style={style}>
      {selectedContent.map((content: Content, i) => {
        return (
          <div key={content.id} className="tac rel p05">
            <ContentPreviewCompact
              content={content}
              prefix={isSingleFileSelection ? "" : i + 1 + "."}
            />
          </div>
        );
      })}
    </div>
  );
}
